module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_11_22_06_off.ed007143.svg";